var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.313,
    height: 212.856,
    viewBox: "0 0 211.313 212.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17974",
    "data-name": "Group 17974",
    transform: "translate(1520.876 2819.142)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 80.099,
    cy: 80.099,
    r: 80.099,
    transform: "translate(-1492.655 -2799.058)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9983",
    "data-name": "Group 9983",
    transform: "translate(-1481.579 -2787.982)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 69.023,
    cy: 69.023,
    r: 69.023,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M752.1,3753.6c7.477,2.167,21.934,10.373,19.94,25.921",
    transform: "translate(-2104.688 -6392.467)",
    fill: "none",
    stroke: "#f7b23b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 7.171,
    cy: 7.171,
    r: 7.171,
    transform: "translate(-1324.406 -2730.314)",
    fill: "none",
    stroke: "#c05efd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 4.44,
    cy: 4.44,
    r: 4.44,
    transform: "translate(-1419.678 -2819.142)",
    fill: "#f3603f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 7.275,
    cy: 7.275,
    r: 7.275,
    transform: "translate(-1520.376 -2756.774)",
    fill: "none",
    stroke: "#f7b23b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 8.05,
    cy: 8.05,
    r: 8.05,
    transform: "translate(-1503.278 -2634.852)",
    fill: "none",
    stroke: "#53b175",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 4.088,
    cy: 4.088,
    r: 4.088,
    transform: "translate(-1409.599 -2606.285) rotate(180)",
    fill: "#53b175"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18117",
    "data-name": "Group 18117",
    transform: "translate(-2146.949 -2818.724)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x2: 45.635,
    y2: 45.635,
    transform: "translate(711.5 76.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    y1: 45.635,
    x2: 45.635,
    transform: "translate(711.5 76.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.31302b60103c9a05afdb487f92b9323f.svg";
export { ForwardRef as ReactComponent };